<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="'Descarga de Sustento'"></app-lfsa-card>

<ng-template #enviarTemplate>
  <div class="tab-content">
    <form [formGroup]="formulario" novalidate class="form-group">
      <div class="row">
        <div [class]="resposiveFull + 'col-xl-2'">
          <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="periodoIcon" (enviarOjeto)="obtenerAnios($event)"
            [placeholder]="'Año'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbAnio" [label]="'Año'"
            [id]="'anio'">
          </app-lfsa-combo-box-mult>
        </div>
        <div [class]="resposiveFull + 'col-xl-2'">
          <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="periodoIcon" (enviarOjeto)="obtenerPeriodo($event)"
            [placeholder]="'Periodo'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbPeriodo"
            [label]="'Periodo'" [id]="'periodo'">
          </app-lfsa-combo-box-mult>
        </div>
        <div [class]="resposiveFull + 'col-xl-2'">
          <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="agenciaIcon"
            (enviarOjeto)="obtenerAngencias($event)" [placeholder]="'Agencias'" [opcion]="'cadena'"
            [idOpcion]="'idOficinaVenta'" [comboBox]="cmbOfiVentas" [label]="'Agencias'" [id]="'agencias'">
          </app-lfsa-combo-box-mult>
        </div>
        <div [class]="resposiveFull + 'col-xl-2'">
          <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="empresaIcon" (enviarOjeto)="obtenerEmpresas($event)"
            [placeholder]="'Empresas'" [opcion]="'dscaEmpresa'" [idOpcion]="'idEmpresa'" [comboBox]="cmbEmpresas"
            [label]="'Empresas'" [id]="'empresas'">
          </app-lfsa-combo-box-mult>
        </div>
        <div [class]="resposiveFull + 'col-xl-2'">
          <app-lfsa-input [mostrarImg]="false" [rutaImagen]="clienteIcon" [control]="formulario.get('clienteDesde')"
            [placeholder]="'Código Desde'" formControlName="clienteDesde" [label]="'Cliente Desde'" [type]="'text'"
            [id]="'clienteDesde'">
          </app-lfsa-input>
        </div>
        <div [class]="resposiveFull + 'col-xl-2'">
          <app-lfsa-input [mostrarImg]="false" [rutaImagen]="clienteIcon" [control]="formulario.get('clienteHasta')"
            [placeholder]="'Código Cliente'" formControlName="clienteHasta" [label]="'Cliente Hasta'" [type]="'text'"
            [id]="'clienteHasta'">
          </app-lfsa-input>
        </div>
        <div [class]="resposiveFull + 'col-xl-2'">
          <app-lfsa-input [mostrarImg]="false" [rutaImagen]="fechaRegIcon" [control]="formulario.get('fechaRegIni')"
            [placeholder]="'Fecha Reg. Ini'" formControlName="fechaRegIni" [label]="'Fecha Reg. Ini'" [type]="'date'"
            [id]="'fechaRegIni'">
          </app-lfsa-input>
        </div>
        <div [class]="resposiveFull + 'col-xl-2'">
          <app-lfsa-input [mostrarImg]="false" [rutaImagen]="fechaRegIcon" [control]="formulario.get('fechaRegFin')"
            [placeholder]="'Fecha Reg. Fin'" formControlName="fechaRegFin" [label]="'Fecha Reg. Fin'" [type]="'date'"
            [id]="'fechaRegFin'">
          </app-lfsa-input>
        </div>
        <div [class]="resposiveFull + 'col-xl-2'">
          <app-lfsa-combo-box [mostrarImg]="false" [rutaImagen]="checkOptionIcon" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbTipoDescarga"
            formControlName="tipoDescarga" [control]="formulario.get('tipoDescarga')" [label]="'Tipo Descarga'" [id]="'tipoDescarga'"
            (change)="validarTipoDescarga()">
          </app-lfsa-combo-box>
        </div>
        <div [class]="resposiveFull + 'col-xl-2'" *ngIf="casrgaDoc">
          <app-lfsa-combo-box [mostrarImg]="false" [rutaImagen]="checkOptionIcon" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbTipoArchivoDescarga"
            formControlName="tipoArchivoDescarga" [control]="formulario.get('tipoArchivoDescarga')" [label]="'Tipo Archivo'" [id]="'tipoArchivoDescarga'">
          </app-lfsa-combo-box>
        </div>
        <div [class]="resposiveFull + 'col-xl-2.5'" *ngIf="casrgaDoc">
          <label for="csvInput" class="letrasDanger">Adjunto*</label>
          <input type="file" class="form-control-file" id="multipart" #fileInput />
        </div>
        <div [class]="resposiveFull + 'form-group col-xl-2'">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" (click)="exportarSustentos()">
            <i class="fa fa-share" aria-hidden="true"></i>
            Exportar</button>
        </div>
      </div>
    </form>
  </div>
  <hr>

  <app-lfsa-card [innTemplate]="enviarTemplateGrid" [titulo]="'Historial de Exportación'" [efecto]="false" [colapseName]="'tabGrid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #enviarTemplateGrid>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <div *ngIf="!loading">
      <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
        No existen datos para la lista de Documentos.
      </div>
      <ag-grid-angular *ngIf="!listaVacia" #agGrid class=" {{sustentosModulo.agGrid.class}}"
        [ngStyle]="sustentosModulo.agGrid.style" id="{{sustentosModulo.agGrid.id}}"
        [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs" [rowSelection]="rowSelection"
        [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true" [floatingFilter]="true"
        [paginationPageSize]="sustentosModulo.agGrid.paginacion">
      </ag-grid-angular>
    </div>
  </ng-template>
  <hr>
  <div class="row">
    <div [class]="resposiveFull + 'form-group col-xl-2'">
      <label>&nbsp;</label><br>
      <button class="btn btn-success btn-block" (click)="decargarArchivo('zip')" >
       <i class="fa fa-download" aria-hidden="true"></i>
        Descargar Zip</button>
    </div>
    <div [class]="resposiveFull + 'form-group col-xl-2'">
      <label>&nbsp;</label><br>
      <button class="btn btn-success btn-block" (click)="decargarArchivo('log')" >
       <i class="fa fa-download" aria-hidden="true"></i>
        Descargar Log</button>
    </div>
  </div>
</ng-template>
